<template>
    <div class="edit-table">
        <vxe-toolbar v-if="!disabled">
            <template v-slot:buttons>
                <vxe-button @click="addTable()">添加行</vxe-button>
            </template>
        </vxe-toolbar>
        <vxe-table :data="cdList">
            <vxe-table-column min-width="100" field="tableNumMin" title="宴席桌数下限">
                <template #default="{ row }">
                    <el-input-number v-model="row.tableNumMin" :disabled="disabled" :controls="false" :precision="0"
                        placeholder="宴席桌数下限"></el-input-number>
                </template>
            </vxe-table-column>
            <vxe-table-column min-width="100" field="tableNumMax" title="宴席桌数上限">
                <template #default="{ row }">
                    <el-input-number v-model="row.tableNumMax" :disabled="disabled" :controls="false" :precision="0"
                        placeholder="宴席桌数上限"></el-input-number>
                </template>
            </vxe-table-column>
            <vxe-table-column min-width="100" field="awardLat" title="奖励纬度">
                <template #default="{ row, rowIndex }">
                    <el-select v-model="row.awardLat" @change="banquetAwardLatTypeChange($event, rowIndex)"
                        placeholder="请选择奖励纬度" :disabled="disabled">
                        <el-option v-for="item in banquetAwardLatTypeList" :key="item.dictCode" :label="item.dictValue"
                            :value="item.dictCode">
                        </el-option>
                    </el-select>
                </template>
            </vxe-table-column>
            <vxe-table-column min-width="100" field="rewardType" title="奖励类型">
                <template #default="{ row, rowIndex }">
                    <el-select v-model="row.rewardType" @change="banquetAwardTypeChange($event, rowIndex)"
                        placeholder="请选择奖励类型" :disabled="disabled">
                        <el-option v-for="item in banquetAwardTypeList" :key="item.dictCode" :label="item.dictValue"
                            :value="item.dictCode">
                        </el-option>
                    </el-select>
                </template>
            </vxe-table-column>
            <vxe-table-column min-width="100" field="rewardAmount" title="每桌奖励费用">
                <template #default="{ row }">
                    <el-input-number v-model="row.rewardAmount" :disabled="disabled" :controls="false" :precision="2"
                        placeholder="每桌奖励费用"></el-input-number>

                </template>
            </vxe-table-column>
            <vxe-column title="操作" width="80" v-if="!disabled">
                <template #default="{ row, rowIndex }">
                    <template>
                        <span @click="deletRow(row, rowIndex)" style="color: red; cursor: pointer">删除</span>
                    </template>
                </template>
            </vxe-column>
        </vxe-table>
    </div>

</template>

<script>
import request from '@/found/utils/request';

export default {
  name: 'scoreRatio',
  components: {

  },
  props: {
    value: Array,
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
    value: {
      handler(val) {
        this.cdList = val;
      },
      deep: true,
    },
  },
  data() {
    return {
      cdList: [], // 当前关联费用科目数据
      banquetAwardTypeList: [], // 奖励类型
      banquetAwardLatTypeList: [], // 奖励纬度
      rIdex: 0,
    };
  },
  async created() {
    await this.getDictSelect();
  },
  mounted() { },
  methods: {
    // 获取数据字典
    getDictSelect() {
      request.post('/mdm/mdmdictdata/batchDictSelect', ['banquet_award_lat_type', 'banquet_award_type']).then((res) => {
        if (res.success) {
          this.banquetAwardTypeList = res.result.banquet_award_type.filter((item) => item.dictCode === 'cash');
          this.banquetAwardLatTypeList = res.result.banquet_award_lat_type.filter((item) => item.dictCode === '2');
        }
      });
    },
    // 删除行
    deletRow(row, rowIndex) {
      console.log(this.cdList);
      this.$confirm('您确定要删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.cdList.splice(rowIndex, 1);
        this.$emit('change', this.cdList);
      });
    },

    // 新增预算信息
    addTable() {
      this.cdList.push({
        tableNumMin: null,
        tableNumMax: null,
        awardLat: null,
        awardLatName: null,
        rewardType: null,
        rewardTypeName: null,
        rewardAmount: null,
      });
      this.$emit('input', this.cdList);
    },

    banquetAwardTypeChange(val, index) {
      console.log(index);
      console.log(val);
      const res = this.banquetAwardTypeList.find(
        (item) => item.dictCode === val,
      );
      this.cdList[index].rewardTypeName = res.dictValue;
    },
    banquetAwardLatTypeChange(val, index) {
      console.log(index);
      console.log(val);
      const res = this.banquetAwardLatTypeList.find(
        (item) => item.dictCode === val,
      );
      this.cdList[index].awardLatName = res.dictValue;
    },

  },
};
</script>

<style lang="less" scoped>
.edit-table {
    padding-left: 50px;
    margin-left: 0 !important;

}

.cost-select {
    position: relative;

    /deep/ .el-input__inner {
        padding-right: 30px;
    }

    .clear-icon {
        width: 25px;
        height: 100%;
        position: absolute;
        right: 5px;
        top: 0;
        text-align: center;
        color: #c0c4cc;
        transition: all 0.3s;
        padding-top: 1px;
        display: none;

        .el-icon-circle-close {
            width: 100%;
            font-size: 14px;
            cursor: pointer;
            transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        }
    }

    &:hover {
        .clear-icon {
            display: block;
        }
    }
}
</style>
